import React from "react";
import { Box, Divider, StackProps, Text, VStack } from "@chakra-ui/react";
import { TableListViewDictionary } from "./TableListViewDictionary";
import { CopyText } from "../Utilities/CopyText";

interface ListViewProps<T> {
  list: T[] | null;
  emptyMessage?: string;
  format?: (value: T) => React.ReactNode;
}

export function ListView<T>({
  list,
  emptyMessage,
  format,
  ...props
}: ListViewProps<T> & StackProps) {
  const formatValue = (value: any) => {
    if (value == null) return <Text>-</Text>;

    switch (typeof value) {
      case "boolean":
        return (
          <Text>{value == true ? "Yes" : value == false ? "No" : "-"}</Text>
        );
      case "object":
        return <TableListViewDictionary dictionary={value as any} />;
      default:
        return (
          <CopyText hover adjustMargin>
            {value}
          </CopyText>
        );
    }
  };

  return (
    <VStack w="100%" alignItems="flex-start" {...props}>
      {(list?.length &&
        list.map((value, idx) => (
          <Box w="100%" key={idx}>
            {format ? format(value) : formatValue(value)}
            {idx != Object.keys(list).length - 1 && (
              <Divider
                variant="section-box"
                marginInlineStart="-1rem !important"
                w="calc(100% + 2rem)"
              />
            )}
          </Box>
        ))) || (
        <Text fontStyle="italic">{emptyMessage ?? "List is empty"}</Text>
      )}
    </VStack>
  );
}
